export default {
    // Vendor
    getPage(state) {
        return state.page;
    },
    searchCanInstantBook(state) {
        return state.instantBooking.searchCanInstantBook;
    },
    orderValidForInstantBooking(state) {
        return state.instantBooking.orderValidForInstantBooking;
    },
    showInstantBooking(state) {
        return state.settings.showInstantBooking;
    },

    // Vendor
    getVendor(state) {
        return state.vendor;
    },

    getSelectedLanguage(state) {
        return state.selectedLanguage;
    },

    // Currency
    getCurrency(state) {
        if (state.rateGroup?.currency) {
            return state.rateGroup?.currency.code;
        }

        if (state.package?.rateGroup.currency) {
            return state.package?.rateGroup.currency;
        }

        if (state.search.complete && state.search.currencyCode) {
            return state.search.currencyCode;
        }

        return state.vendor?.default_currency_code;
    },

    // Event type
    getEventTypes(state) {
        return state.eventTypes;
    },

    // Calendar
    getAvailabilityCalendarRooms(state) {
        return state.availabilityCalendarRooms;
    },
    getAvailabilityCalendarSpaces(state) {
        return state.availabilityCalendarSpaces;
    },

    // Event type
    getEventType(state) {
        return state.eventType;
    },

    // Packages
    getPackages(state) {
        return state.packages;
    },

    // Search
    getPackage(state) {
        return state.package;
    },

    // Themes
    getThemes(state) {
        return state.themes;
    },

    // Classes
    getClasses(state) {
        return state.classes;
    },

    // Order
    getOrder(state) {
        return state.order;
    },

    // Order
    getSettings(state) {
        return state.settings;
    },

    // Search
    getSearch(state) {
        return state.search;
    },

    // Price calendar
    getPriceCalendar(state) {
        return state.priceCalendar;
    },

    // Price calendar
    getLoading(state) {
        return state.loading;
    },
};
